<template lang="html">
  <div id="home-page">

    <section class="container-fluid banner-section">
      <swiper class="swiper-desktop" :options="bannersOption">
        <swiper-slide v-for="(banner, bInx) in banners.pc" :key="'bInx-'+bInx">
          <a class="d-block placed-backg" v-bind:style="{ backgroundImage: 'url('+banner.imagen+')' }" :href="banner.url">
            <img src="public/images/pages/home/banner.png">
          </a>
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>

      <swiper class="swiper-mobile" :options="bannersOption">
        <swiper-slide  v-for="(banner, bmInx) in banners.movil" :key="'bmInx-'+bmInx">
          <a class="d-block placed-backg" v-bind:style="{ backgroundImage: 'url('+banner.imagen+')' }" :href="banner.url">
            <img src="public/images/pages/home/banner-m.png">
          </a>
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </section>

    <!-- <section class="divisor-section"></section> -->

    <section class="categories-section">
      <swiper class="swiper" :options="categoriesOptions">
        <swiper-slide v-for="(c, ch) in featuredCategories" :key="'ch-'+ch">
          <router-link class="t-250 box-category" :to="'/categoria/'+$root._converToURL(c.name, c.id)" v-bind:style="{ backgroundImage: 'url('+c.imageUrl+')' }">
            <div class="box">
              <div class="inside">
                <h5>{{ c.name }}</h5>
              </div>
            </div>

            <img class="empty" src="public/images/pages/home/category.png">
          </router-link>
        </swiper-slide>
      </swiper>
    </section>

    <!-- <section class="categories-v2-section">
      <div class="container">
        <div class="row main-row">
          <div class="col-12 col-title">
            <h2 class="title-s1">Categorías</h2>
          </div>

          <div class="col-12">
            <div class="row">
              <div class="col-12 col-lg-6 col-xl-4 col-categories" v-for="(c, chInx) in categories" :key="'chInx-'+chInx">
                <div class="content">
                  <h5 class="category-name">{{ c.name }}</h5>

                  <div class="box-subcategories">
                    <div class="col-12 col-subcategory" v-if="c.supersubcategory != null">
                      <router-link class="t-150 box-subcat" :to="'/subcategoria/'+$root._converToURL(c.supersubcategory.name, c.supersubcategory.id)">
                        <div class="placed-backg image xl" v-bind:style="{ backgroundImage: 'url('+c.supersubcategory.imageUrl+')' }">
                          <img src="public/images/shared/product-lg-1.png">
                        </div>

                        <h6>{{ c.supersubcategory.name }}</h6>
                      </router-link>
                    </div>

                    <div class="col-6 col-subcategory" v-for="(s, shInx) in c.subcategories" v-else>
                      <router-link class="t-150 box-subcat" :to="'/subcategoria/'+$root._converToURL(s.name, s.id)">
                        <div class="placed-backg image" v-bind:style="{ backgroundImage: 'url('+s.imageUrl+')' }">
                          <img src="public/images/shared/product.png">
                        </div>

                        <h6>{{ s.name }}</h6>
                      </router-link>
                    </div>

                    <div class="col-12 col-more">
                      <router-link :to="'/subcategoria/'+$root._converToURL(c.supersubcategory.name, c.supersubcategory.id)" v-if="c.supersubcategory != null">Ver más</router-link>
                      <router-link :to="'/categoria/'+$root._converToURL(c.name, c.id)" v-else>Ver más</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section class="categories-section">
      <swiper class="swiper" :options="categoriesOptions">
        <swiper-slide v-for="(c, ch) in categories" :key="'ch-'+ch">
          <router-link v-if="c.subcategories.length" class="t-250 box-category" :to="'/categoria/'+$root._converToURL(c.name, c.id)" v-bind:style="{ backgroundImage: 'url('+c.imageUrl+')' }" style="background-size:cover !important;">
            <div class="box">
              <div class="inside">
                <h5>{{ c.name }}</h5>
              </div>
            </div>

            <img class="empty" src="public/images/shared/empty.png">
          </router-link>

           <router-link v-else class="t-250 box-category" :to="'/categoria/'+$root._converToURL(c.name, c.id)" v-bind:style="{ backgroundImage: 'url('+c.imageUrl+')' }" style="background-size:cover !important;">
            <div class="box">
              <div class="inside">
                <h5>{{ c.name }}</h5>
              </div>
            </div>

            <img class="empty" src="public/images/shared/empty.png">
          </router-link>

        </swiper-slide>
      </swiper>
    </section> -->

    <!-- <section class="register-section-s1">
      <router-link class="t-250 btn-register btn-green" to="/asociarse">Regístrate para vender</router-link>
    </section> -->

    <section class="container oversized-container mb-4 pt-4 products-section">
      <div class="row">
        <div class="col-12 mb-1 col-title">
          <h2 class="title-s1">Productos</h2>
        </div>

        <div class="col-12 col-products">
          <swiper class="swiper carousel-t1 ct1-white" :options="productsOption">
            <swiper-slide v-for="(product, prhInx) in products" :key="'prhInx-'+prhInx">
              <div class="col-12 px-0 sample-product shad-prod">
                <router-link class="outlined-box" :to="'/producto/'+$root._converToURL(product.name, product.id)">
                  <div class="box-image">
                    <!-- <div class="out-of-stock" v-if="product.stock < 1">Agotado</div> -->

                    <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.img+')' }">
                      <img src="public/images/shared/product.png" >
                    </div>
                  </div>

                  <div class="box-shot-descr">
                    <h6 class="sku">{{ product.sku }}</h6>
                    <h6 class="name para-5">{{ product.name }}</h6>
                    <h6 class="brand">{{ product.category }}</h6>

                    <h6 class="price" v-bind:class="{ 'discount' : product.activate_discount }" style="min-height: 51px;">
                        <!-- PRECIO TACHADO SIN DESCUENTO-->
                        <span class="cross" v-if="product.type_disc == 'descuento_envio' || product.type_disc == 'descuento'">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} </span>
                        <!-- PRECIO NORMAL-->
                        <span v-else-if="product.type_disc == null || product.type_disc == 'envio'">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} </span>
                        <!-- PRECIO FINAL CON DESCUENTO-->
                        <span v-if="product.type_disc == 'descuento_envio' || product.type_disc == 'descuento'">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format( product.price_discount) }} <i class="off">{{ $root.discountPct(product.price, product.price_discount) }}% OFF</i></span>
                        <!-- ENVIO GRATIS-->
                        <span class="free-shipping" v-if="product.type_disc == 'descuento_envio' || product.type_disc == 'envio'"><i class="fas fa-shipping-fast"></i> Envío gratis</span>
                    </h6>
                    <h6 v-if="product.stock > 0" class="stock">{{ product.stock }} en stock</h6>
                    <h6 v-else style="color: gray;">Sin stock</h6>
                    
                    <div class="box-shipping-type">
                      <span class="icon i-1"></span>
                      <span class="text">Envío rápido</span>
                    </div>
                  </div>
                  <!-- <p class="p-button">
                    <a class="btn-more">Ver más</a>
                  </p> -->
                </router-link>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </section>

    <section class="container oversized-container mb-4 mid-banners-section">
      <div class="row">
        <div class="col-12">
          <swiper class="swiper-desktop" :options="bannersMidOption">
            <swiper-slide v-for="(ban, bs2Inx) in banners.secundarios_superior" :key="'bs2Inx-'+bs2Inx">
              <div class="col-12 px-0 col-banner">
                <a class="placed-backg" target="_blank" v-bind:style="{ backgroundImage: 'url('+ban.imagen+')' }" :href="ban.url">
                  <img src="public/images/pages/home/banner-mid.png">
                </a>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>

       <!--  <div class="col-lg-6 col-banner">
          <a class="placed-backg" v-bind:style="{ backgroundImage: 'url(public/images/pages/home/banner-mid.jpg)' }" href="#">
            <img src="public/images/pages/home/banner-mid.png">
          </a>
        </div> -->
      </div>
    </section>

    <!-- MARK: About info -->
    <!-- <ExtraAboutComponent /> -->
    <!--  -->

    <!-- <section class="blog-section">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-12 mb-3 text-center col-title">
            <h2 class="title-s1">Blog</h2>
          </div>

          <div class="col-12 col-articles">
            <swiper class="swiper" :options="blogOptions">
              <swiper-slide v-for="(article, ahInx) in blogs" :key="'ahInx-'+ahInx">
                <div class="col-12 px-0 article-sample-1">
                  <router-link class="t-250 placed-backg article-link" v-bind:style="{ backgroundImage: 'url('+article.imageUrl+')' }" :to="'/blog/'+article.id">
                    <img class="empty" src="public/images/shared/empty.png">

                    <div class="inside">
                      <div class="t-250 show">Ver más</div>
                      <div class="shadow"></div>
                      <div class="box-txt">
                        <h5>{{article.title}}</h5>
                        <h6>Hoy, hace 1 hora.</h6>

                        <div class="descr">
                          <p>
                            Descripción breve del comunicado para pactar el interés del usuario.
                          </p>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </swiper-slide>


              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section class="container oversized-container mb-3 brands-section">
      <div class="row">
        <div class="col-12 mb-2 col-title">
          <h2 class="text-center title-s1">Ya están con nosotros</h2>
        </div>

        <div class="col-12 col-brands">
          <swiper class="swiper" :options="brandsOptions">
            <swiper-slide v-for="(entrepreneur, brhInx) in entrepreneurs" :key="'brhInx-'+brhInx">
              <div class="box-brand">
                <router-link target="_blank" :to="'/emprendedor/'+$root._converToURL(entrepreneur.brand, entrepreneur.id)">
                  <div class="inside">
                    <img :src="entrepreneur.image_url">
                  </div>
                </router-link>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section> -->

    <section class="mb-4 products-section w-bg">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-12 mb-2 col-title">
            <h2 class="title-s1">Ofertas que no puedes perderte</h2>
          </div>

          <div class="col-12 col-products">
            <swiper class="swiper carousel-t1 ct1-white" :options="productsOption">
              <swiper-slide v-for="(product, prhInx) in discountProducts" :key="'prhInx-'+prhInx">
                <div class="col-12 px-0 sample-product shad-prod">
                  <router-link class="outlined-box" :to="'/producto/'+$root._converToURL(product.name, product.id)">
                    <div class="box-image">
                      <!-- <div class="out-of-stock" v-if="product.stock < 1">Agotado</div> -->

                      <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.img+')' }">
                        <img src="public/images/shared/product.png" >
                      </div>
                    </div>

                    <div class="box-shot-descr">
                      <h6 class="sku">{{ product.sku }}</h6>
                      <h6 class="name para-5">{{ product.name }}</h6>
                      <h6 class="brand">{{ product.category }}</h6>

                      <h6 class="price" v-bind:class="{ 'discount' : product.activate_discount }" style="min-height: 51px;">
                          <!-- PRECIO TACHADO SIN DESCUENTO-->
                          <span class="cross" v-if="product.type_disc == 'descuento_envio' || product.type_disc == 'descuento'">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} </span>
                          <!-- PRECIO NORMAL-->
                          <span v-else-if="product.type_disc == null || product.type_disc == 'envio'">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} </span>
                          <!-- PRECIO FINAL CON DESCUENTO-->
                          <span v-if="product.type_disc == 'descuento_envio' || product.type_disc == 'descuento'">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format( product.price_discount) }} <i class="off">{{ $root.discountPct(product.price, product.price_discount) }}% OFF</i></span>
                          <!-- ENVIO GRATIS-->
                          <span class="free-shipping" v-if="product.type_disc == 'descuento_envio' || product.type_disc == 'envio'"><i class="fas fa-shipping-fast"></i> Envío gratis</span>
                      </h6>
                      <h6 v-if="product.stock > 0" class="stock">{{ product.stock }} en stock</h6>
                      <h6 v-else style="color: gray;">Sin stock</h6>

                      <div class="box-shipping-type">
                        <span class="icon i-1"></span>
                        <span class="text">Envío rápido</span>
                      </div>
                    </div>
                    <!-- <p class="p-button">
                      <a class="btn-more">Ver más</a>
                    </p> -->
                  </router-link>
                </div>
              </swiper-slide>

              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>

    <section class="mid-banners-section mb-4 pt-2 pb-1">
      <div class="container oversized-container">
        <div class="row">
          <div class="col-12">
            <swiper class="swiper-desktop" :options="bannersMidOption">
              <swiper-slide v-for="(ban, bs3Inx) in banners.secundarios_inferior" :key="'bs3Inx-'+bs3Inx">
                <div class="col-12 px-0 col-banner">
                  <a class="placed-backg" target="_blank" v-bind:style="{ backgroundImage: 'url('+ban.imagen+')' }" :href="ban.url">
                    <img src="public/images/pages/home/banner-mid.png">
                  </a>
                </div>
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>

    <section class="register-section-s1 mb-0">
      <router-link class="t-250 btn-register btn-pink" to="/registrarse">¡Regístrate ya!</router-link>
    </section>

    <sweet-modal ref="modalLoading" hide-close-button blocking >
      <modalLoadingComponent></modalLoadingComponent>
      <p style="font-weight: 600; font-size: 1.1rem;">Cargando, espere ...</p>
    </sweet-modal>

  </div>
</template>

<script>
import ExtraAboutComponent from './about-us/extra-info-component.vue';
export default {
  components: {
    ExtraAboutComponent
  },

  data(){
    return{
      banners: {
        pc :[],
        movil: []
      },
      categories:[],
      subcategories:[
        // { id: 1, name: 'dfgdf', imageUrl: 'dfdf'}
      ],
      products:[
        // { id: 1, img: null, name: null, sku: null, stock: null, price: null, offer_price: null, type_disc: null, category: null },
      ],
      discountProducts: [],
      entrepreneurs:[],
      blogs: [
        //{ id: 1, imageUrl: 'public/images/pages/blog/article-1.jpg', title: 'Joyería Sostenible: Lo Mejor de la Moda Ética para Este Año' },
      ],
      brands: [
        // { imageUrl: 'public/images/pages/home/brand-1.png' },
        // { imageUrl: 'public/images/pages/home/brand-2.png' },
        // { imageUrl: 'public/images/pages/home/brand-3.png' },
      ],

      categories: [
        // { name: 'Categoría 1', imageUrl: 'public/images/pages/categories/c-1.jpg', subcategories: [
        //     { imageUrl: 'public/images/pages/categories/c1.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c1.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c1.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c1.jpg', name: 'Subcategoría x' },
        //   ]
        // },
        // { name: 'Categoría 2', imageUrl: 'public/images/pages/categories/c-2.jpg', subcategories: [
        //     { imageUrl: 'public/images/pages/categories/c2.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c2.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c2.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c2.jpg', name: 'Subcategoría x' },
        //   ]
        // },
        // { name: 'Categoría 3', imageUrl: 'public/images/pages/categories/c-3.jpg', subcategories: [
        //     { imageUrl: 'public/images/pages/categories/c3.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c3.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c3.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c3.jpg', name: 'Subcategoría x' },
        //   ]
        // },
        // { name: 'Otra Categoría', imageUrl: 'public/images/pages/categories/c-4.jpg', subcategories: [
        //     { imageUrl: 'public/images/pages/categories/c4.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c4.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c4.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c4.jpg', name: 'Subcategoría x' },
        //   ]
        // },
        // { name: 'Otra Categoría', imageUrl: 'public/images/pages/categories/c-5.jpg', subcategories: [
        //     { imageUrl: 'public/images/pages/categories/c5.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c5.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c5.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c5.jpg', name: 'Subcategoría x' },
        //   ]
        // },
        // { name: 'Otra Categoría', imageUrl: 'public/images/pages/categories/c-6.jpg', subcategories: [
        //     { imageUrl: 'public/images/pages/categories/c6.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c6.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c6.jpg', name: 'Subcategoría x' },
        //     { imageUrl: 'public/images/pages/categories/c6.jpg', name: 'Subcategoría x' },
        //   ]
        // },
      ],
      featuredCategories: [],

      // == Carousel options ==
      bannersOption: {
        loop: true,
        speed:800,
        // effect: 'fade',

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
      },

      bannersMidOption: {
        loop: true,
        speed: 800,
        effect: 'fade',

        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
          clickable: true,
        },

        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
      },

      categoriesv2Options: {
        slidesPerView: 3,
        spaceBetween: 16,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        breakpoints: {
          1200: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 2,
          },
          1: {
            slidesPerView: 1,
          },
        }
      },

      categoriesOptions: {
        loop: false,
        speed:800,
        slidesPerView: 5,
        spaceBetween: 15,

        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },

        breakpoints: {
          1600: {
            slidesPerView: 5,
          },
          1200: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 3,
          },
          576: {
            slidesPerView: 2,
          },
          1: {
            slidesPerView: 1,
          },
        }
      },

      productsOption: {
        loop: true,
        slidesPerView: 5,
        spaceBetween: 15,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1599: {
            slidesPerView: 5
          },
          1299: {
            slidesPerView: 4
          },
          991: {
            spaceBetween: 15,
            slidesPerView: 3
          },
          575: {
            spaceBetween: 15,
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        }
      },

      blogOptions: {
        slidesPerView: 4,
        spaceBetween: 30,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        breakpoints: {
          1300: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          1: {
            slidesPerView: 1,
          },
        }
      },

      brandsOptions: {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 20,

        autoplay: {
          delay: 4500,
          disableOnInteraction: false
        },

        breakpoints: {
          1200: {
            slidesPerView: 4,
          },
          992: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 2,
          },
          0: {
            slidesPerView: 1,
          },
        }
      },
      slidersname:{
        carrusel_one:null,
        carrusel_two:null,
        carrusel_three:null
      }

      // == ==
    }
  },

  methods:{
    getBanners(){
      axios.get(tools.url("/api/banners")).then((response)=>{
        this.banners=response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },

    getCategories(){
      axios.get(tools.url("/api/categoriesFrontHome")).then((response)=>{
        this.categories = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },

    getFeaturedCategories(){
      axios.get(tools.url("/api/featured-categories")).then((response)=>{
        this.featuredCategories = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },

    getBlogs(){
      axios.get(tools.url("/api/blogs")).then((response)=>{
        this.blogs = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },

    getProducts(){
      axios.get(tools.url("/api/home-products")).then((response)=>{
        this.products = response.data.randoms;
        this.discountProducts = response.data.discounts;
      }).catch((error)=>{
        console.log(error);
      });
    },

    getEntrepreneurs(){
      axios.get(tools.url("/api/entrepreneurshome")).then((response)=>{
        this.entrepreneurs = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },

    getSubcategories(){
      axios.get(tools.url("/api/subcategoriesFront")).then((response)=>{
        this.subcategories = response.data;
      }).catch((error)=>{
        console.log(error);
      });
    },

    getSliderName(){
      axios.get(tools.url("/api/sliders")).then((response)=>{
        this.slidersname = response.data;
      }).catch((error)=>{
        console.log(error);
      });
		},
  },

  mounted() {
      this.$refs.modalLoading.open();
      this.getSliderName();
      this.getBanners();
      // this.getCategories();
      this.getFeaturedCategories();
      // this.getBlogs();
      this.getProducts();
      this.getEntrepreneurs();
      // this.getSubcategories();

      var slef = this;
      setTimeout(function(){
          slef.$refs.modalLoading.close();
      }, 2000);
  }
}
</script>
